import Regex from 'utils/regex';

const InputFormatter = {
  Float: (value: string, isDE = false) => {
    const separator = isDE ? ',' : '.';
    let sanitizedValue = isDE
      ? value.replace('.', ',')
      : value.replace(',', '.');
    sanitizedValue = sanitizedValue.replace(Regex.Float(isDE), '');
    return sanitizedValue.split(separator).slice(0, 2).join(separator);
  },

  Integer: (value: string, isDE = false) => {
    const separator = isDE ? ',' : '.';
    value = value.split(separator)[0];
    return value.replace(Regex.Integer, '');
  },

  Currency: (value: string, isDE = false) => {
    if (!value.trim()) {
      return '';
    }

    let formattedValue = value.replace(/[^\d,.-]/g, ''); // Remove non-numeric characters

    if (isDE) {
      formattedValue = new Intl.NumberFormat('de-DE').format(
        Number(formattedValue.replace(/\./g, '').replace(/,/g, '.')),
      );
    } else {
      formattedValue = new Intl.NumberFormat('en-GB').format(
        Number(formattedValue.replace(/,/g, '')),
      );
    }
    return formattedValue;
  },
};

export default InputFormatter;
